/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_house': {
    width: 32,
    height: 25,
    viewBox: '0 0 32 25',
    data: '<path pid="0" d="M14.337 24.5a3.5 3.5 0 0 1 4.795-1.597c.12-.086.243-.17.368-.248M14.337 24.5H31.5v-14m-17.163 14H8.5v-8.758m5.837 8.758H29.5a7.488 7.488 0 0 0-6-3c-1.47 0-2.842.423-4 1.155m12-12.155h-12v2m12-2l-7-7h-7l-2.321 2.321M19.5 12.5h-4.027m4.027 0v10.155M6.5 12A4.5 4.5 0 0 1 11 7.5m-4.5 9v3m0 0v5h3m-3-5l-3-2M15.179 5.821c.209.69.321 1.421.321 2.179 0 .789-.122 1.549-.347 2.263a4.485 4.485 0 0 1 .32 2.237m-.294-6.679a7.5 7.5 0 1 0-13.747 5.801 3.5 3.5 0 1 0 5.752 3.833 7.59 7.59 0 0 0 .985.043 4.5 4.5 0 0 0 .331.244m6.973-3.242a4.493 4.493 0 0 1-1.644 3m-5.329.242a4.48 4.48 0 0 0 2.5.758c.925 0 1.785-.28 2.5-.758m.329-.242H16.5v3h-3v-2.758m.329-.242a4.514 4.514 0 0 1-.329.242m.329-.242l-.329.242m9-1.242h6v3h-6v-3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_house.js